import React, { FC } from "react";
import { Control, ControllerFieldState, useController } from "react-hook-form";

import Checkbox, { CheckBoxProps } from "@/components/ui/Form/CheckBox/CheckBoxBase";

export interface InputControlledProps extends CheckBoxProps {
  control: Control;
}
const InputControlled: FC<InputControlledProps> = ({ control, ...rest }) => {
  const { name } = rest;
  const { field, fieldState } = useController({ control, name });
  return <Checkbox field={field} fieldState={fieldState} {...rest} />;
};
export default InputControlled;
